import { AnyAction } from 'redux';

type Matchable<AC extends () => AnyAction> = AC & {
  type: ReturnType<AC>['type'];
  doesMatch(action: AnyAction): action is ReturnType<AC>;
};

function withMatcher<AC extends () => AnyAction>(
  actionCreator: AC
): Matchable<AC>;
function withMatcher<
  AC extends (...arguments_: never[]) => AnyAction & { type: string }
>(actionCreator: AC): Matchable<AC>;
function withMatcher<AC extends (...arguments_: never[]) => AnyAction>(
  actionCreator: AC,
  type: ReturnType<AC>['type']
): Matchable<AC>;
function withMatcher(
  // eslint-disable-next-line @typescript-eslint/ban-types
  actionCreator: Function & { type?: string },
  _type?: string
) {
  const type = _type ?? actionCreator.type ?? actionCreator().type;
  return Object.assign(actionCreator, {
    type,
    doesMatch(action: AnyAction) {
      return action.type === type;
    },
  });
}

export default withMatcher;
